/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IFavoriteFolderSchema } from '../../entities/add_favorite/FavoriteFolderSchema';

export type TAddFavoriteModel = IModel<IAddFavoriteRequest, TAddFavoriteResponse>;

export interface IAddFavoriteRequest {
  /** Добавлять ли в папку, если у пользователя есть недавно редактированная папка **/
  addToFolder?: boolean | null;
  /** Тип сделки **/
  dealType: EDealType;
  /** Идентификатор объявления **/
  entityId: number;
  /** Тип объекта **/
  entityType: EEntityType;
}

export type TAddFavoriteResponse = IAddFavoriteResponse200 | IAddFavoriteResponse400;

export interface IAddFavoriteResponse200 extends IModelResponse<IAddFavoriteResponse> {
  statusCode: 200;
}

export interface IAddFavoriteResponse400 extends IModelResponse<IAddFavoriteResponseError> {
  statusCode: 400;
}

export interface IAddFavoriteResponse {
  /** Папка в избранном **/
  folder?: IFavoriteFolderSchema | null;
  /** Есть ли у пользователя папки **/
  hasFolders?: boolean | null;
  /** Было ли добавлено в избранное **/
  isAdded: boolean;
  /** Id ЖК **/
  newbuildingId: number;
}

export interface IAddFavoriteResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IAddFavoriteResponse | IAddFavoriteResponseError;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EEntityType {
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Коммерческая **/
  OfferCommercial = 'offerCommercial',
  /** Жилая **/
  OfferResidental = 'offerResidental',
  /** Загородка **/
  OfferSuburban = 'offerSuburban',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IAddFavoriteResponse): TResponse200;
  400(response: IAddFavoriteResponseError): TResponse400;
}
